"use client";

import { Container } from "@/components/Container";
import { MaskReveal, Reveal, RevealImage } from "@/components/Motion";
import { Accordion } from "@/components/Accordion";
import { whyChoose } from "@/lib/home";
import { CmsText, cmsImg } from "@/components/CmsText";

// "Why Choose Table Space" — full-width heading + intro, then a two-column
// band: a static image on the LEFT and the five benefits as dropdown
// accordions on the RIGHT (same accordion pattern used site-wide).
export function Why({ c = {} }: { c?: Record<string, string> } = {}) {
  return (
    <section className="border-t border-brand-line bg-brand-paper">
      <Container className="py-28 md:py-40">
        <h2 className="t-display text-brand-ink">
          <MaskReveal lines={[<span key="a">Why Choose <span className="text-brand-accent">Table Space?</span></span>]} />
        </h2>
        <CmsText c={c} k="why.intro" as="p" className="mt-8 text-base font-normal leading-relaxed text-brand-slate md:text-lg">
          Table Space brings deep expertise in delivering scalable,
          high-performance managed office solutions that meet the evolving needs
          of modern enterprises. Our Grade A Workspace-as-a-Service (WaaS)
          offering is designed for GCCs and global enterprises, combining
          efficiency, speed, flexibility, transparency, and continuous
          transformation.
        </CmsText>

        <div className="mt-14 grid items-start gap-12 md:grid-cols-[0.95fr_1.05fr] md:gap-16">
          {/* left — static image */}
          <Reveal className="md:sticky md:top-28">
            <div className="overflow-hidden rounded-2xl ring-1 ring-brand-line">
              <RevealImage
                src={cmsImg(c, "why.image", "/images/home/why-choose-edsc.webp")}
                alt="A Table Space managed office interior"
                cmsKey="why.image"
                className="aspect-[4/3] h-full w-full object-cover [filter:contrast(1.03)_saturate(1.04)] md:aspect-[4/5]"
              />
            </div>
          </Reveal>

          {/* right — the five benefits as dropdown accordions */}
          <Reveal delay={0.1} className="md:pt-2">
            <Accordion
              items={whyChoose.map((w, i) => ({
                title: <CmsText c={c} k={`why.items.${i}.title`}>{w.title}</CmsText>,
                body: <CmsText c={c} k={`why.items.${i}.body`} as="div">{w.body}</CmsText>,
              }))}
            />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
